export default __webpack_public_path__ + "static/media/cs-campaigns-new.3a0d1092.png";